import React, { useEffect, useState } from "react";
import "./LoadingScreen.css";

export default function LoadingScreen({ children }) {
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDone(true);
    }, 1300); // mismo tiempo que tu animación

    return () => clearTimeout(timer);
  }, []);

  if (isDone) return children; // ← se desmonta por completo

  return (
    <div className="loading-container">
      <img src="/sharp.jpg" alt="loading" className="loading-logo" />
    </div>
  );
}
